import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
  },

  authCardContainer: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    position: 'relative',
    width: '40%',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
      width: '100%',
    },
  },

  authBackgroundContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  fullBackground: {
    width: '100% !important',
    display: 'flex !important',
  },

  authBackground: {
    height: '100%',
    width: '100%',
    left: 0,
    maxWidth: '100%',
    objectFit: 'cover',
    position: 'absolute',
    top: 0,
  },

  imgBg: {
    background: `#0066CB 0% 0% no-repeat padding-box`,
    height: '100%',
    left: 0,
    opacity: 0.8,
    position: 'absolute',
    top: 0,
    width: '100%',
  },

  logoDescription: {
    color: '#FFFFFF',
    textAlign: 'center',
  },

  logoContainer: {
    maxWidth: 600,
    position: 'relative',
    textAlign: 'center',
  },

  logoContainerFullBg: {
    marginTop: 80,
  },

  launchMobilityFont: {
    color: theme.palette.primary.main,
  },

  welcomeText: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
  },

  name: {
    fontWeight: theme.typography.fontWeightBold,
  },

  authLink: {
    '& a': {
      color: theme.palette.secondary.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      '& :hover': {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  },

  copyright: {
    bottom: 60,
    fontSize: theme.typography.pxToRem(14),
    position: 'absolute',
  },

  root: {
    boxSizing: 'border-box',
    maxWidth: 450,
    minHeight: 300,
    padding: 25,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },

  supportContainer: {
    position: 'absolute',
    top: 87,
    right: 140,
    [theme.breakpoints.down('sm')]: {
      top: 10,
      right: 55,
    },
  },

  support: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      top: 10,
    },
  },
  footer: {
    marginTop: 'auto',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#fff',
    width: '100%',
    height: 50,
  },
}));

export default useStyles;
